module.exports = __webpack_public_path__ + "files/e6ddf84d9a4f84457e652626360afc05.png";